import RefundSummaryView from '@/components/refund/RefundSummaryView';
import { type RefundOffersDTO } from '@/types/dto/agent';
import { type FC } from 'react';

// Derived entirely from the offer(s), so the deep-link flow needs no booking or
// manage-slice data. A full refund can expand to several offers, so the amounts
// are summed; the original price paid is what's refunded back plus the fee.
const RefundAmountSummary: FC<{ refundOffers: RefundOffersDTO }> = ({
  refundOffers,
}) => {
  const { refundFee, refundableAmount } = (
    refundOffers.refundOffers ?? []
  ).reduce(
    (acc, offer) => ({
      refundFee: acc.refundFee + (offer.refundFee?.amount ?? 0),
      refundableAmount:
        acc.refundableAmount + (offer.refundableAmount?.amount ?? 0),
    }),
    { refundFee: 0, refundableAmount: 0 }
  );

  return (
    <RefundSummaryView
      totalPrice={refundableAmount + refundFee}
      refundFee={refundFee}
      refundAmount={refundableAmount}
    />
  );
};

export default RefundAmountSummary;
